module.exports = __webpack_public_path__ + "img/lk-hero-img-side.0b2e781d.svg";